export const isVisualizador = (role?: string | null): boolean =>
  role === 'VISUALIZADOR';

export const isCoordenador = (role?: string | null): boolean =>
  role === 'COORDENADOR';

export const hasRole = (
  role: string | null | undefined,
  allowedRoles: string[]
): boolean => allowedRoles.includes(role || '');
